import * as React from "react";
import type { SVGProps } from "react";
const SvgMenuKebab = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g fill="currentColor" clipPath="url(#menu-kebab_svg__a)">
      <path d="M12 14c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2M5 14c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2M19 14c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2" />
    </g>
    <defs>
      <clipPath id="menu-kebab_svg__a">
        <path fill="#fff" d="M3 10h18v4H3z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgMenuKebab;
